import RegisterSectionRenderer from "./RegisterSectionRenderer";

function RegisterBasic(props: any) {
    return <RegisterSectionRenderer {...props} />;
}

export default RegisterBasic
